
<div class="table-header" [ngSwitch]="sortable">
  <div *ngSwitchCase="true" class="d-flex">
    <button
      type="button"
      (click)="handleClick()"
      class="table-header-button"
      [class.two-line-header]="columnMetadata?.isTwoLineHeader"
    >
      <ng-container *ngTemplateOutlet="content"></ng-container>
      <mat-icon class="table-sort-button__sort-icon" *ngIf="sortable" [svgIcon]="sortIcon"></mat-icon>
    </button>
  </div>
  <ng-container *ngSwitchDefault>  
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </ng-container>
</div>

<ng-template #content>
  <ng-content></ng-content>
</ng-template>